/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconDownload, IconEye, IconPlus, IconX } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import ListView from "../../../components/common/ListView";
import { useNavigate } from "react-router-dom";
import ToggleButton from "../../../components/ToggleButton";
import { usePermission } from "../../../hooks/usePermissionTabs";
import { useLanguage, T } from "../../../context/LanguageContext";
import {
  useFetchProductItemData,
  useUpdateProductItemStatus,
} from "../../../apis/productApis";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import toast from "react-hot-toast";
import MessageModal from "../../../components/MessageModal";
import EntriesSelector from "../../../components/common/EntriesSelector";
import NoDataFound from "../../../components/common/NoDataFound";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import Pagination from "../../../components/common/Pagination";
import useDebounce from "../../../utilities/useDebounce";
import { useSelector } from "react-redux";
import {
  useLocationBarcodeVerifyMutation,
  useShipmentInventoryAddMutation,
  useShipmentInventoryListData,
} from "../../../hooks/inventoryHooks";
import AddInventoryModal from "./AddInventoryModal";
import NewCommonModal from "../../../components/common/NewCommonModal";
import { useForm } from "react-hook-form";
import { useLinehualManifestGenerateMutation } from "../../../apis/pickupApis";
const ItemInventoryData = [
  {
    id: 1,
    itemName: "Apples",
    sku: "SKU001",
    category: "Fruits",
    brand: "Himalya",
    warehouse: "Riyadh-001",
    storageType: "Cold",
    capacity: "10",
    weight: "5 kg",
    comCode: "IND256",
    expiry: "12 Days",
    price: "100",
    status: "Shelf",
    active: false,
  },
  {
    id: 2,
    itemName: "Apples",
    sku: "SKU001",
    category: "Fruits",
    brand: "Himalya",
    warehouse: "Riyadh-001",
    storageType: "Cold",
    capacity: "10",
    weight: "5 kg",
    comCode: "IND256",
    expiry: "12 Days",
    price: "100",
    status: "Shelf",
    active: false,
  },
  {
    id: 3,
    itemName: "Apples",
    sku: "SKU001",
    category: "Fruits",
    brand: "Himalya",
    warehouse: "Riyadh-001",
    storageType: "Cold",
    capacity: "10",
    weight: "5 kg",
    comCode: "IND256",
    expiry: "12 Days",
    price: "100",
    status: "Shelf",
    active: false,
  },
  {
    id: 4,
    itemName: "Apples",
    sku: "SKU001",
    category: "Fruits",
    brand: "Himalya",
    warehouse: "Riyadh-001",
    storageType: "Cold",
    capacity: "10",
    weight: "5 kg",
    comCode: "IND256",
    expiry: "12 Days",
    price: "100",
    status: "Shelf",
    active: false,
  },
  {
    id: 5,
    itemName: "Apples",
    sku: "SKU001",
    category: "Fruits",
    brand: "Himalya",
    warehouse: "Riyadh-001",
    storageType: "Cold",
    capacity: "10",
    weight: "5 kg",
    comCode: "IND256",
    expiry: "12 Days",
    price: "100",
    status: "Shelf",
    active: false,
  },
];

export default function ItemInventory({ 
  warehouseId,
  searchQuery,
  portalContainer
}: { 
  warehouseId?: string;
  searchQuery?: string;
  portalContainer?: HTMLDivElement | null;
}) {
  const { t } = useLanguage();
  type FormValues1 = {
    fromWarehouseId: string;
    toWarehouseId: string;
  };

  type FormValues = {
    id: string;
    assignType: string;
    linehaulCompanyId: string;
    assignedDriver: string;
    driverId: string;
  };

  const {
    register: assignRegister,
    handleSubmit: handleRequestSubmit,
    clearErrors: clearAssignErrors,
    setValue: setAssignValue,
    watch: assignWatch,
    reset: assignReset,
    formState: { errors: assignErrors },
  } = useForm<FormValues1>();

  const {
    register: register,
    handleSubmit: handleSubmit,
    clearErrors: clearErrors,
    setValue: setValue,
    watch: watch,
    reset: reset,
    formState: { errors: errors },
  } = useForm<FormValues>();

  const navigate = useNavigate();
  const { allowed: canCreateShipment } = usePermission("shipment_inventory", "create");
  const { allowed: canUpdateProduct } = usePermission("products", "update");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [localSearch, setLocalSearch] = useState<string>("");
  const searchFor = searchQuery !== undefined ? searchQuery : localSearch;
  const setSearchFor = searchQuery !== undefined ? () => {} : setLocalSearch;
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [actionModal, setActionModal] = useState<boolean>(false);
  const [openShelve, setOpenShelve] = useState<boolean>(false);
  const [locationId, setLocationId] = useState<string>("");

  const openShelveToggleModal = () => {
    setOpenShelve(!openShelve);
  };
  const [isOpen, setIsOpen] = useState(false);

  const [openBulk, setOpenBulk] = useState<boolean>(false);
  const openBulkToggleModal = () => {
    setOpenBulk(!openBulk);
  };
  const [awbText, setAwbText] = useState<any>("");
  const debouncedSearchFor = useDebounce(searchFor, 550);

  const { data, isLoading, isFetching, error, refetch } =
    useShipmentInventoryListData(pageNo, limit, debouncedSearchFor, warehouseId);

  const { mutate: addShipmentInventory, isPending: isAddingProduct } =
    useShipmentInventoryAddMutation();

  // const data = useSelector((state: any) => state?.product?.data);

  const { mutate: updateProductStatus, isPending: statusPending } =
    useUpdateProductItemStatus();

  const handleToggleStatus = (item: any) => {
    setSelectedItem(item);
    setActionModal(true);
  };

  const confirmUpdateStatus = async () => {
    if (!canUpdateProduct) {
      toast.error(t("You do not have permission to update items."));
      return;
    }
    const newStatus = selectedItem?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    updateProductStatus(
      { id: selectedItem?.id, status: newStatus },
      {
        onSuccess: () => {
          refetch();
          toast.success(t("Status updated successfully"));
          setActionModal(false);
        },
        onError: (error) => {
          toast.error(`${error}`);
        },
      }
    );
  };

  useEffect(() => {
    refetch();
  }, [pageNo, limit, debouncedSearchFor, warehouseId]);

  useEffect(() => {
    setPageNo(1);
  }, [warehouseId]);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const [columnsData, setColumnsData] = useState([
    { text: "S/N", value: "sn", isShow: true },
    { text: "AWB", value: "awb", isShow: true },
    { text: "Reference ID", value: "referenceNumber", isShow: true },
    { text: "Client", value: "clientName", isShow: true },
    { text: "Origin", value: "origin", isShow: true },
    { text: "Destination", value: "destination", isShow: true },
    // { text: "Type", value: "type", isShow: true },
    // { text: "Warehouse", value: "warehouseName", isShow: true },
    { text: "ShelfId", value: "shelfId", isShow: true },
    { text: "Status", value: "status", isShow: true },
    // { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col
      )
    );
  };

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "sn":
          return {
            label: t("#"),
            render: (_: any, i: number) => (pageNo - 1) * limit + (i + 1),
          };
        case "awb":
          return {
            label: t("AWB"),
            render: (c: any) => c.awb,
          };
        case "referenceNumber":
          return {
            label: t("Reference ID"),
            render: (c: any) => c.referenceNumber,
          };
        case "clientName":
          return {
            label: t("Client"),
            render: (c: any) => c.clientName,
          };
        case "origin":
          return {
            label: t("Origin"),
            render: (c: any) => c.origin,
          };
        case "destination":
          return {
            label: t("Destination"),
            render: (c: any) => (
              <div className="flex flex-col text-left">
                {/* City + Country */}
                <div
                  className="text-xs font-bold text-[#212121] truncate"
                  title={`${c.receiverCity || ""}${c.receiverCountry ? `, ${c.receiverCountry}` : ""}`}
                >
                  {c.receiverCity || ""}
                  {c.receiverCountry ? `, ${c.receiverCountry}` : ""}
                </div>

                {/* District */}
                {c.receiverDistrict && (
                  <div className="text-[9px] text-slate-400 font-bold flex items-center gap-1 mt-1">
                    <span
                      className="truncate"
                      title={`${t("Dist")}: ${c.receiverDistrict}`}
                    >
                      {t("Dist")}: {c.receiverDistrict}
                    </span>
                  </div>
                )}
              </div>
            ),
          };
        // case "type":
        //   return {
        //     label: "Type",
        //     render: (c: any) =>c.type,
        //   };
        case "warehouseName":
          return {
            label: t("Warehouse"),
            render: (c: any) => c.warehouseName,
          };
        case "shelfId":
          return {
            label: t("Location ID"),
            render: (c: any) => c.locationName,
          };
        case "status":
          return {
            label: t("Status"),
            render: (c: any) => {
              return (
                <div className="flex justify-center">
                  <button
                    className={`rounded-full  px-4 py-1 text-center bg-[#20BF55] text-[#ffffff]`}
                  >
                    {t("Shelved")}
                  </button>
                </div>
              );
            },
          };
        // case "actions":
        //   return {
        //     label: "Actions",
        //     render: (item: any) => (
        //       <div className="text-center">
        //         <button
        //           // onClick={() => navigate(`/add-item/${item.id}`)}
        //           className="p-2 border rounded-full bg-[#F7F6F2]"
        //         >
        //           <IconEye size={22} />
        //         </button>
        //       </div>
        //     ),
        //   };
        default:
          return { label: "", render: () => null };
      }
    });

  const handleSendRequest = (data: any) => {
    const awbNumbers = awbText.split(/[\s,\n]+/).filter(Boolean);

    addShipmentInventory(
      {
        locationId: locationId,
        orderId: awbNumbers,
      },
      {
        onSuccess: () => {
          toast.success(t("Linehaul request generated successfully"));
          openBulkToggleModal();
          // resetForm();
          refetch();
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  const { mutate: sendCompanyRequest, isPending: sendPending } =
    useLinehualManifestGenerateMutation();

  const actionControls = (
    <>
      {/* Search */}
      {searchQuery === undefined && (
        <NormalSearch
          value={searchFor}
          onChange={(e) => {
            setSearchFor(e.target.value);
            setPageNo(1);
          }}
        />
      )}

      {/* Export/Download */}
      <button
        className="flex items-center justify-center p-1.5 bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-md transition shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150"
        title={t("Export")}
      >
        <IconDownload size={17} stroke={2.5} />
      </button>

      {/* Add Inventory Button */}
      {canCreateShipment && (
        <button
          onClick={openBulkToggleModal}
          className="flex items-center justify-center p-1.5 bg-[#FBD037] hover:bg-[#e2bd30] border border-[#FBD037] text-[#131327] rounded-md transition shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150 font-bold"
          title={t("Add Inventory")}
        >
          <IconPlus size={17} stroke={2.5} />
        </button>
      )}

      {/* Entries Limit Selector */}
      {data && data.totalPages * limit > 10 && (
        <EntriesSelector
          value={limit}
          options={[
            10,
            ...(data.totalPages * limit > 10 ? [20] : []),
            ...(data.totalPages * limit > 20 ? [30] : []),
            ...(data.totalPages * limit > 50 ? [50] : []),
            ...(data.totalPages * limit > 100 ? [100] : []),
          ]}
          onChange={(val) => {
            setLimit(val);
            setPageNo(1);
          }}
        />
      )}

      {/* Columns Hide/Show Filter */}
      <ColumnsFilter columnsData={columnsData.map(c => ({...c, text: t(c.text)}))} setHeadings={setHeadings} />
    </>
  );

  return (
    <div className="flex flex-col lg:flex-row gap-6 items-start w-full">
      {portalContainer && createPortal(actionControls, portalContainer)}

      {/* Left Column: Main Card / Table */}
      <div className={`${openBulk ? "lg:w-[60%] w-full" : "w-full"} flex-1 min-w-0`}>
        {/* ── Main Card (Header + Table Joined) ─────────────────────── */}
        <div
          className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-visible mb-6"
          style={{ minHeight: "150px" }}
        >
          {/* Table Container (Joined) */}
          <div className="">
            {isLoading ? (
              <TableSkeleton
                columns={columnsData.filter((c) => c.isShow).map((c) => c.text)}
                rows={6}
              />
            ) : data?.inventoryMovement?.length ? (
              <ListView data={data?.inventoryMovement} columns={columns} />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>

        <div className="flex justify-center items-center py-4">
          {data && data.totalPages > 1 && (
            <Pagination
              currentPage={pageNo}
              totalPages={data.totalPages}
              fetchData={handlePaginationFetch}
            />
          )}
        </div>
      </div>

      {/* Right Column: Add Inventory Sidebar Card */}
      {openBulk && (
        <div className="lg:w-[40%] w-full flex-shrink-0 sticky top-4 bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden flex flex-col">
          {/* Header Row */}
          <div className="flex items-center justify-between border-b border-slate-150 p-4 bg-gradient-to-r from-white to-slate-50/50">
            <h2 className="text-lg font-bold text-[#131327]"><T>Add Inventory</T></h2>
            <button 
              onClick={openBulkToggleModal}
              className="p-1.5 rounded-full hover:bg-slate-100 text-slate-500 transition flex items-center justify-center"
              title={t("Close")}
            >
              <IconX size={18} />
            </button>
          </div>

          {/* Form Content */}
          <AddInventoryModal
            setValue={setAssignValue as any}
            awbText={awbText}
            setAwbText={setAwbText}
            setLocationId={setLocationId}
            locationId={locationId}
            warehouseId={warehouseId}
          />

          {/* Actions Footer */}
          <div className="flex justify-end gap-3 p-4 border-t border-slate-150 bg-white">
            {canCreateShipment && (
              <button
                onClick={handleRequestSubmit(handleSendRequest)}
                disabled={isAddingProduct}
                className="px-4 py-2 bg-[#FBD037] hover:bg-[#e2bd30] text-[#131327] font-bold rounded-xl transition flex items-center gap-2 shadow-sm"
              >
                {isAddingProduct ? t("Updating...") : t("Update Inventory")}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
